module.exports = __webpack_public_path__ + "img/logo_momo.11764487.png";